/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.2.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "index.css"

import {Spinner} from "reactstrap";
import {CookiesProvider, withCookies} from "react-cookie";
import { createRedirectEntry } from './auth/redirectEntry';
import { createBrowserSessionPort, createSessionTransition } from './auth/sessionTransition';
import { createSessionMutation } from './auth/sessionMutation';
import { bindSessionAPI } from './api/API';
import { redirectSession } from './api/AuthAPI';

const hist = createBrowserHistory();
const session = createSessionTransition(createBrowserSessionPort(window))
const redirectEntries = createRedirectEntry(window, session)
// This must precede importing App/i18n: those imports previously could fetch
// country data while the callback query still contained the credential.
const redirectEntry = redirectEntries.capture()
if (!redirectEntry) session.initialize()
const authRuntime = {
  session,
  client: bindSessionAPI(session, window.location.href),
  mutation: createSessionMutation(window, session),
  redirect(entry) {
    return this.mutation.run({
      kind: 'redirect',
      entry,
      operation: async ({ attempt, auth, invalidateOnly, signal }) => {
        if (invalidateOnly) return (await this.client.post('/logout', null, { attempt, signal })).data
        return redirectSession({ auth }, { client: this.client, attempt, signal })
      },
    })
  },
}
require('./i18n')
const AppWithCookies = withCookies(require('layouts/Admin.js').default)
const RedirectEntry = require('./views/Redirect/Redirect').default
// Set the document theme before mounting, including Suspense and body portals.

ReactDOM.render(
  <Suspense fallback={<Spinner />}>
    <CookiesProvider>
      <Router history={hist}>
          <Switch>
              <Route exact path="/redirect" render={props => {
                  // Client-side navigation has no new module evaluation, so capture here too.
                  const entry = redirectEntry || redirectEntries.capture()
                  return <RedirectEntry {...props} authRuntime={authRuntime} redirectEntry={entry} />
              }} />
              <Route path="/" render={(props) => <AppWithCookies {...props} authRuntime={authRuntime} />} />
              <Redirect to="/" />
          </Switch>
      </Router>
    </CookiesProvider>
  </Suspense>,
  document.getElementById("root")
);
